AFRAME.registerComponent('anim-fov', {
  schema: {
    type: 'number',
    default: 80,
  },

  init: function() {
    this.update()

    Object.defineProperty(this, 'amount', {
      get: function() {
        return this.camera.fov
      },
      set: function(val) {
        this.camera.fov = val
        this.camera.updateProjectionMatrix()
      },
    })
  },

  update: function() {
    let data = this.data
    let object3D = this.el.object3D
    for (var i = 0; i < object3D.children.length; i++) {
      let child = object3D.children[i]
      if (child.fov) {
        this.camera = child
      }
    }
  },

  remove: function() {
    // Pretty much for mixins.
    this.el.object3D.scale.set(1, 1, 1)
    this.camera.fov = this.schema.default
  },
})
